// The Moon's phase as a small picture (Tonight, the Ramaḍān view).

export function MoonGlyph({ phase, size = 36 }: { phase: number; size?: number }) {
  // phase: 0 new, 90 first quarter, 180 full, 270 last quarter.
  const f = (1 - Math.cos((phase * Math.PI) / 180)) / 2; // lit fraction
  const waxing = phase < 180;
  const r = size / 2 - 1;
  const k = 1 - 2 * f; // terminator ellipse x-radius factor
  const sweepLit = waxing ? 1 : 0;
  const rx = Math.abs(k) * r;
  const d = `M ${size / 2} 1 A ${r} ${r} 0 0 ${sweepLit} ${size / 2} ${size - 1} A ${rx} ${r} 0 0 ${k > 0 ? (waxing ? 0 : 1) : waxing ? 1 : 0} ${size / 2} 1 Z`;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} fill="#1b2133" />
      <path d={d} fill="#efe9dc" />
    </svg>
  );
}

/** On the 29th, the 30th and the 1st the Moon is just a crescent (src/live/saudi.ts): its own phase, the right way
 *  round (the old crescent before the new Moon, the new one after), but never so near new that it cannot be seen. */
export const crescentPhase = (phase: number) => (phase > 180 ? Math.min(phase, 340) : Math.max(phase, 20));

/** The least of the Moon lit in a small picture of it on those days: as 20° from new (crescentPhase). The sky and the
 *  Moon card's globe show it as it is. */
export const CRESCENT_LEAST = (1 - Math.cos((20 * Math.PI) / 180)) / 2;
